import React from 'react';
import Symptoms from './symptoms/Symptoms';
import { MessageDialog } from '../../../../../core/components/dialogs/messageDialog';

interface SymptomsDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const SymptomsDialog: React.FC<SymptomsDialogProps> = (
  props: SymptomsDialogProps
) => {
  return (
    <MessageDialog
      title="Online scheduling is for non-urgent appointments"
      isOpen={props.isOpen}
      onDismiss={props.onClose}
      maxWidth={790}
    >
      <Symptoms />
    </MessageDialog>
  );
};

export default SymptomsDialog;
